<div class="container">
  <div class="button-container">
    <button mat-raised-button [color]="color" class="width-100" (click)="selectFile()">
      {{label}}
    </button>
  </div>

  <input
    #fileUpload
    id="fileUpload"
    name="fileUpload"
    type="file"
    [accept]="accept"
    (change)="writeValue(fileUpload.files[0])"
  />
  <app-file-label-view [file]="fileForm.value" *ngIf="fileForm.value && preview"></app-file-label-view>
</div>
